import React from 'react';
import PropTypes from 'prop-types';
import Dictionary from '../../../../model/Dictionary';
import MealsList from './MealsList';
import { DialogContent, Button } from 'material-ui';
import MainController from '../../../../controllers/MainController';

const MealsListWrapper = ({
  routeId,
  showOnlySelected,
  RowAction,
  onRowAction,
  onItemClickAction,
  selectable,
  selectedPassenger,
  addNew,
}) => (
  <div>
    <MealsList
      routeId={routeId}
      activePassenger={selectedPassenger}
      showOnlySelected={showOnlySelected}
      onItemClickAction={onItemClickAction}
      RowAction={RowAction}
      onRowAction={onRowAction}
      selectable={selectable}
    />
    {!addNew ? null : (
      <DialogContent>
        <Button
          raised
          fullWidth={MainController.showMobileVersion()}
          color='primary'
          onClick={() => onRowAction(0)}
        >
          {Dictionary.passengers.add}
        </Button>
      </DialogContent>
    )}
  </div>
);

MealsListWrapper.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  onItemClickAction: PropTypes.any,
  RowAction: PropTypes.any,
  onRowAction: PropTypes.any,
  selectable: PropTypes.bool,
  addNew: PropTypes.bool,
  selectedPassenger: PropTypes.string,
  showOnlySelected: PropTypes.bool,
};

export default MealsListWrapper;



// WEBPACK FOOTER //
// ./src/containers/meals/desktop/mealsList/MealsListWrapper.js